import { useState } from 'react';
import PropTypes from 'prop-types';

import './table.scss';

import SearchBar from '../search_bar/search_bar';

import { ReactComponent as FilterFieldsSVG } from 'icons/table/filter-fields.svg';
import { ReactComponent as SortFieldsSVG } from 'icons/table/sort-desc.svg';
import { ReactComponent as CaretLeftSVG } from 'icons/table/caret-left.svg';
import { ReactComponent as CaretRightSVG } from 'icons/table/caret-right.svg';
import { ReactComponent as SearchSVG } from 'icons/table/search.svg';
import { columnShape, metaShape } from 'helpers/shared_types';

const ViewBar = ({
  columns,
  meta,
  fetching,
  selectedOptions,
  onNextPage,
  onPrevPage,
  onSearch,
  isSearchable = true,
}) => {
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchText, setSearchText] = useState('');

  const filteredBy = [],
    sortedBy = [];

  columns.forEach((c) => {
    if (
      c.isFilterable &&
      c.options.length !== selectedOptions[c.accessor]?.length
    ) {
      filteredBy.push(c.label);
    }
    if (c.isSortable) sortedBy.push(c.sortLabel);
  });

  if (fetching) return <div className="view-bar"></div>;

  const fromNumber = (meta.currentPage - 1) * meta.itemsPerPage + 1;
  const toNumber =
    meta.currentPage * meta.itemsPerPage > meta.totalItems
      ? meta.totalItems
      : meta.currentPage * meta.itemsPerPage;
  const total = meta.totalItems;

  return (
    <div className="view-bar flex flex-column">
      <div className="flex-auto flex items-center">
        <div className="flex items-center justify-between w-100">
          <div className="flex items-center">
            {isSearchable && (
              <div
                aria-label="Search"
                className="th-table-search focus-visible mr3 pointer"
                onClick={() => setShowSearchBar(!showSearchBar)}
              >
                <div
                  data-cy="search"
                  className="flex justify-center items-center pointer"
                >
                  <SearchSVG />
                </div>
              </div>
            )}
            <div aria-label="Filter rows" className="focus-visible mr1">
              {filteredBy.length === 0 ? (
                <div className="flex items-center btn-view-bar">
                  <FilterFieldsSVG />
                  <div className="ml2 fw6">Unfiltered</div>
                </div>
              ) : (
                <div className="flex items-center btn-view-bar bg-green-2">
                  <FilterFieldsSVG />
                  <div className="ml2 fw6">
                    Filtered by {filteredBy.join(', ')}
                  </div>
                </div>
              )}
            </div>
            <div aria-label="Sort rows" className="focus-visible mr1 ml2">
              {sortedBy.length === 0 ? (
                <div className="flex items-center btn-view-bar">
                  <SortFieldsSVG />
                  <div className="ml2 fw6">Unsorted</div>
                </div>
              ) : (
                <div className="flex items-center btn-view-bar bg-cyan">
                  <SortFieldsSVG />
                  <div className="ml2 fw6">Sorted by {sortedBy.join(', ')}</div>
                </div>
              )}
            </div>
            <div aria-label="Search rows" className="focus-visible mr1 ml2">
              {searchText && (
                <div className="flex items-center btn-view-bar bg-purple-l4">
                  <SearchSVG />
                  <div className="ml2 fw6">Searched by {searchText}</div>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-column items-center">
            <div className="flex">
              <div data-cy="pagination-text" className="mr5 midgrey">
                Showing {fromNumber}-{toNumber} of {total} records
              </div>
              <div
                data-cy="prev-page"
                className="th-caret mr2 flex justify-center items-center pointer"
                onClick={onPrevPage}
              >
                <CaretLeftSVG />
              </div>
              <div
                data-cy="next-page"
                className="th-caret flex justify-center items-center pointer"
                onClick={onNextPage}
              >
                <CaretRightSVG />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showSearchBar && (
        <div className="th-viewbar-search mt2">
          <SearchBar
            placeholder="Search for any keyword"
            searchText={searchText}
            onSearch={onSearch}
            setSearchText={setSearchText}
          />
        </div>
      )}
    </div>
  );
};

ViewBar.propTypes = {
  columns: PropTypes.arrayOf(columnShape),
  meta: metaShape,
  fetching: PropTypes.bool,
  selectedOptions: PropTypes.shape({
    doctor: PropTypes.arrayOf(PropTypes.string),
    nextAction: PropTypes.arrayOf(PropTypes.string),
    manualPaymentStatus: PropTypes.arrayOf(PropTypes.string),
    recordingStatus: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.arrayOf(PropTypes.string),
    technician: PropTypes.arrayOf(PropTypes.string),
  }),
  onNextPage: PropTypes.func,
  onPrevPage: PropTypes.func,
  onSearch: PropTypes.func,
};

export default ViewBar;
